import { Profiler } from '@weblite/profiler'
import { dispatchSetConnectionStatus } from '$comp/main/root.action'
import { ProfilerAction } from '$logic/profiler'

export const connectWebSocketProfiler = new Profiler(
  ProfilerAction.WEB_SOCKET_CONNECTION,
)

export default () => {
  connectWebSocketProfiler.start()
  analite('TRY_TO_CONNECT_WEB_SOCKET')
  dispatchSetConnectionStatus('authenticating')
}
